import * as React from 'react';
import React__default, { forwardRef } from 'react';
import { B as BASE_CONSUMER_ASSETS_URL } from './global-2e5d81b9.js';
import Box from './Box.js';
import useTheme from './useTheme.js';
import 'styled-components';

var _path$1y;
function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }
var SvgAirplane$2 = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 16 16"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2V9.6l-6.737-4V1.2C9.263.536 8.7 0 8 0S6.737.536 6.737 1.2v4.4L0 9.6v1.6l6.737-2v4.4l-1.684 1.2V16L8 15.2l2.947.8v-1.2l-1.684-1.2V9.2l6.737 2Z"
  })));
};

var _path$1x;
function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
var SvgRepeatEvent = function SvgRepeatEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 14 14"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    d: "M1.986 12.414c-.305 0-.57-.112-.793-.335a1.084 1.084 0 0 1-.336-.793V2.57a1.1 1.1 0 0 1 .336-.807c.223-.224.488-.335.792-.335h.858V.57h1.071v.858h4.571V.57h1.072v.858h.857a1.1 1.1 0 0 1 .807.335 1.1 1.1 0 0 1 .336.807V6.8h-1.143V5.214H1.986v6.072h4.3v1.128h-4.3Zm8.214 1.2a2.878 2.878 0 0 1-1.857-.643 2.861 2.861 0 0 1-1.029-1.6h1.243c.114.315.319.579.614.793.295.215.638.322 1.029.322.505 0 .938-.181 1.3-.543.362-.362.543-.795.543-1.3 0-.514-.181-.95-.543-1.307a1.785 1.785 0 0 0-1.3-.536c-.238 0-.46.038-.664.114a1.432 1.432 0 0 0-.522.329h.729v1.143H7.085V7.729h1.13v.685c.256-.228.556-.412.9-.55a2.878 2.878 0 0 1 1.085-.207c.828 0 1.53.29 2.107.872.576.58.864 1.285.864 2.114 0 .819-.288 1.519-.864 2.1a2.855 2.855 0 0 1-2.107.871Z"
  })));
};

var _path$1w;
function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.658 4.775 5.432A.896.896 0 0 0 3.508 6.7l3.896 3.896c.33.33.864.33 1.194 0l3.895-3.896a.896.896 0 0 0-1.266-1.267L8.001 8.658Z"
  })));
};

var _path$1v;
function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }
var SvgCalendar$1 = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    d: "M3.76.5c-.356 0-.651.272-.651.6v.6H1.152C.774 1.7.5 1.952.5 2.3v2.1h15V2.3c0-.348-.274-.6-.652-.6H12.89v-.6c0-.328-.295-.6-.652-.6h-.652c-.357 0-.652.272-.652.6v.6h-5.87v-.6c0-.328-.295-.6-.652-.6h-.652Zm0 .6h.653v1.8h-.652V1.1Zm7.827 0h.652v1.8h-.652V1.1ZM.5 6.2v8.736c0 .327.274.564.652.564h13.696c.378 0 .652-.237.652-.564V6.2H.5Z"
  })));
};

var _rect$3, _path$1u, _rect2$2;
function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }
var SvgCheckboxSelected$1 = function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 1,
    y: 0.5,
    fill: "#046720",
    rx: 3.5
  })), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.707 4.793a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L7 9.086l4.293-4.293a1 1 0 0 1 1.414 0Z"
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 1,
    y: 0.5,
    stroke: "#046720",
    rx: 3.5
  })));
};

var _rect$2, _rect2$1;
function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
var SvgCheckboxUnselected$1 = function SvgCheckboxUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 1,
    y: 0.5,
    fill: "#fff",
    rx: 3.5
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 1,
    y: 0.5,
    stroke: "#E0E0E0",
    rx: 3.5
  })));
};

var _rect$1, _path$1t, _rect2;
function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }
var SvgCheckboxRoundedSelected = function SvgCheckboxRoundedSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 1,
    y: 0.5,
    fill: "#046720",
    rx: 9.5
  })), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.758 5.991a1.25 1.25 0 0 1 0 1.768l-6.25 6.25a1.25 1.25 0 0 1-1.767 0l-2.5-2.5A1.25 1.25 0 0 1 7.009 9.74l1.616 1.617L13.99 5.99a1.25 1.25 0 0 1 1.768 0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 1,
    y: 0.5,
    stroke: "#046720",
    rx: 9.5
  })));
};

var _rect;
function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }
var SvgCheckboxRoundedUnselected = function SvgCheckboxRoundedUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 1,
    y: 0.5,
    stroke: "#595959",
    rx: 9.5
  })));
};

var _path$1s;
function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }
var SvgCheckmark$1 = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 7.521A1 1 0 1 0 1.3 8.95l1.4-1.428ZM5.84 12l-.7.714a1 1 0 0 0 1.4 0L5.84 12Zm8.86-7.286a1 1 0 0 0-1.4-1.428l1.4 1.428ZM1.3 8.95l3.84 3.765 1.4-1.428L2.7 7.52 1.3 8.95Zm5.24 3.765 8.16-8-1.4-1.428-8.16 8 1.4 1.428Z"
  })));
};

var _path$1r;
function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }
var SvgEndLocation$1 = function SvgEndLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  })));
};

var _path$1q;
function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
var SvgInfo$1 = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.6a6.4 6.4 0 1 0 0 12.8A6.4 6.4 0 0 0 8 1.6Zm.533 9.6H7.467V7.467h1.066V11.2ZM8 6.133a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6Z"
  })));
};

var _path$1p;
function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 6.933a1.067 1.067 0 1 0 0 2.134h10.666a1.067 1.067 0 1 0 0-2.134H2.667Z"
  })));
};

var _path$1o;
function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    d: "M12.175 1.6c-.273 0-.546.104-.754.313L10.133 3.2 12.8 5.867l1.287-1.288a1.067 1.067 0 0 0 0-1.508L12.93 1.912a1.064 1.064 0 0 0-.754-.312ZM9.067 4.267l-6.262 6.261s.49-.044.672.139c.182.182.032 1.376.256 1.6.224.224 1.41.066 1.58.236.17.17.159.692.159.692l6.261-6.262-2.666-2.666Zm-6.934 8-.503 1.425a.533.533 0 0 0 .678.678l.006-.002.013-.005c.001 0 .002 0 .003-.002l1.403-.494-.8-.8-.8-.8Z"
  })));
};

var _path$1n;
function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var SvgPin$1 = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    d: "M8.001.085A6.452 6.452 0 0 0 1.55 6.537c0 4.242 4.195 6.273 4.72 6.746.537.483.98 1.565 1.16 2.178.086.298.33.449.571.455a.61.61 0 0 0 .573-.455c.179-.613.622-1.695 1.159-2.178.525-.473 4.72-2.504 4.72-6.746A6.452 6.452 0 0 0 8.001.085Zm0 8.211a1.76 1.76 0 1 1 0-3.519 1.76 1.76 0 0 1 0 3.519Z"
  })));
};

var _path$1m;
function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    d: "M7.984 1.585a1.067 1.067 0 0 0-1.05 1.082v4.266H2.666a1.067 1.067 0 1 0 0 2.134h4.266v4.266a1.067 1.067 0 1 0 2.134 0V9.067h4.266a1.067 1.067 0 1 0 0-2.134H9.067V2.667a1.067 1.067 0 0 0-1.083-1.082Z"
  })));
};

var _path$1l;
function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var SvgSearch$1 = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.225 7.012a3.212 3.212 0 1 1-6.425 0 3.212 3.212 0 0 1 6.425 0Zm-.362 4.124a5.012 5.012 0 1 1 1.273-1.273l2.527 2.528a.9.9 0 1 1-1.272 1.272l-2.528-2.527Z",
    clipRule: "evenodd"
  })));
};

var _path$1k;
function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var SvgAirplane$1 = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2V9.6l-6.737-4V1.2C9.263.536 8.7 0 8 0S6.737.536 6.737 1.2v4.4L0 9.6v1.6l6.737-2v4.4l-1.684 1.2V16L8 15.2l2.947.8v-1.2l-1.684-1.2V9.2l6.737 2Z"
  })));
};

var _path$1j;
function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var SvgAc = function SvgAc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 1.59a.8.8 0 0 0-.788.81v2.069l-1.034-1.035a.8.8 0 1 0-1.132 1.132L11.2 6.73V8.08a3.98 3.98 0 0 0-2.181 1.276l-1.181-.683-.793-2.959a.8.8 0 1 0-1.545.414l.378 1.414-1.792-1.034a.8.8 0 0 0-.46-.113.8.8 0 0 0-.34 1.497l1.792 1.035-1.412.38a.8.8 0 1 0 .414 1.545l2.957-.794 1.185.684A3.954 3.954 0 0 0 8 12c0 .442.09.86.222 1.258l-1.184.684-2.958-.794a.804.804 0 0 0-.758.181.8.8 0 0 0 .344 1.365l1.412.38-1.792 1.034a.8.8 0 1 0 .8 1.384l1.792-1.034-.378 1.414a.8.8 0 1 0 1.545.414l.793-2.96 1.18-.682A3.98 3.98 0 0 0 11.2 15.92v1.349l-2.166 2.165a.8.8 0 1 0 1.132 1.132L11.2 19.53V21.6a.8.8 0 1 0 1.6 0v-2.069l1.034 1.035a.8.8 0 1 0 1.132-1.132L12.8 17.27V15.92a3.981 3.981 0 0 0 2.181-1.276l1.182.683.792 2.959a.8.8 0 1 0 1.545-.414l-.378-1.414 1.792 1.034a.801.801 0 1 0 .8-1.384l-1.792-1.035 1.412-.38a.8.8 0 1 0-.414-1.545l-2.958.794-1.184-.684c.133-.398.222-.816.222-1.258 0-.442-.09-.86-.222-1.258l1.184-.684 2.958.794a.8.8 0 1 0 .414-1.546l-1.412-.38 1.792-1.034a.8.8 0 1 0-.8-1.384l-1.792 1.034.378-1.414a.8.8 0 1 0-1.545-.414l-.792 2.96-1.182.682A3.981 3.981 0 0 0 12.8 8.08V6.73l2.166-2.165a.8.8 0 1 0-1.132-1.132L12.8 4.47V2.4a.8.8 0 0 0-.813-.81Zm-.06 8.018a.801.801 0 0 0 .145 0c.79.024 1.484.425 1.904 1.034a.8.8 0 0 0 .17.305c.157.319.253.673.253 1.053 0 .43-.122.828-.32 1.177a.815.815 0 0 0-.036.067 2.388 2.388 0 0 1-1.972 1.148.793.793 0 0 0-.145 0A2.395 2.395 0 0 1 9.6 12c0-.378.095-.73.25-1.048a.8.8 0 0 0 .172-.31 2.394 2.394 0 0 1 1.906-1.034ZM12 11.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6Z"
  })));
};

var _path$1i;
function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var SvgAirplane = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M9.666 27.333v-1.4l2.667-2v-8.366L.667 19v-1.933L12.333 10.2V2.333c0-.466.161-.86.483-1.183A1.61 1.61 0 0 1 14 .667c.466 0 .86.16 1.183.483.322.322.483.717.483 1.183V10.2l11.667 6.867V19l-11.666-3.433v8.366l2.666 2v1.4L14 26.1l-4.334 1.233Z"
  })));
};

var _path$1h, _path2$7;
function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M22.5 17.867c0 1.178-.895 2.133-2 2.133h-17c-1.104 0-2-.955-2-2.133V6.133C1.5 4.955 2.396 4 3.5 4h17c1.105 0 2 .955 2 2.133v11.734Z"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.127 10.25-1.056 2.341L9.02 10.25H7.672v3.363L6.17 10.25H5.034L3.5 13.74h.907l.336-.779h1.716l.341.78h1.733v-2.593l1.149 2.593h.781l1.176-2.548v2.548h.861V10.25h-1.373Zm-6.06 1.957.513-1.22.534 1.22H5.067Zm13.875-.25 1.558-1.698h-1.108l-.997 1.082-.965-1.091H14v3.491h3.317l1.046-1.155 1.02 1.164h1.105l-1.546-1.793Zm-2.078 1.051h-2.006v-.69h1.92v-.662h-1.92v-.654l2.117.006.847.949-.958 1.051Z"
  })));
};

var _path$1g;
function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var SvgAndroidAuto = function SvgAndroidAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.918 17.483 11.04 2.4a1 1 0 0 1 1.706-.008l9.312 15.083a1 1 0 0 1-.85 1.525h-4.252H18L12 7 6 19h1.043-4.27a1 1 0 0 1-.855-1.517ZM7.043 19 12 9.5l4.956 9.5L18 21l-6-2-6 2 1.043-2Z",
    clipRule: "evenodd"
  })));
};

var _path$1f;
function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M20.452 7.828c-.098.062-2.44 1.362-2.44 4.244.11 3.287 2.955 4.44 3.004 4.44-.049.062-.43 1.57-1.558 3.152-.895 1.362-1.888 2.736-3.397 2.736-1.435 0-1.95-.908-3.607-.908-1.778 0-2.281.908-3.643.908-1.509 0-2.576-1.447-3.52-2.797-1.226-1.766-2.269-4.538-2.305-7.2-.025-1.41.245-2.797.932-3.974.968-1.644 2.698-2.76 4.587-2.797 1.447-.049 2.735.994 3.618.994.847 0 2.429-.994 4.22-.994.772 0 2.833.234 4.109 2.196ZM12.001 5.35c-.258-1.288.453-2.576 1.116-3.397C13.963.959 15.3.285 16.453.285a4.803 4.803 0 0 1-1.227 3.471c-.748.994-2.036 1.742-3.225 1.594Z"
  })));
};

var _g$3, _defs$5;
function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var SvgApplePay = function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple-pay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.792 7.36c-.4.02-.895.275-1.178.634-.26.31-.481.811-.425 1.283.453.039.907-.236 1.189-.585.278-.359.461-.84.414-1.331Zm3.849.96v7.2H9.78v-2.4h1.56c1.433 0 2.46-.996 2.46-2.4s-1.01-2.4-2.422-2.4H8.641Zm1.139.96h1.32c.982 0 1.56.53 1.56 1.44 0 .91-.573 1.44-1.56 1.44H9.78V9.28Zm-5.04.24c-.66 0-1.132.36-1.44.36-.313 0-.78-.357-1.32-.357-.66 0-1.306.415-1.647 1.02-.7 1.206-.182 2.994.495 3.977.332.487.732 1 1.272 1 .495-.018.662-.3 1.26-.3.6 0 .78.3 1.32.3s.867-.495 1.198-.98c.378-.553.533-1.092.542-1.12-.009-.008-1.046-.407-1.056-1.604-.009-1.002.817-1.48.855-1.507-.467-.692-1.24-.789-1.42-.789h-.058Zm11.676.72c-1.195 0-2.077.67-2.11 1.591h1.013c.083-.437.498-.725 1.065-.725.688 0 1.077.315 1.077.894v.4l-1.406.075c-1.307.078-2.013.6-2.013 1.513 0 .92.73 1.532 1.775 1.532.706 0 1.363-.351 1.66-.907h.023v.853h1.04v-3.538c0-1.027-.837-1.687-2.124-1.687Zm2.543 0 1.925 5.255-.103.32c-.173.542-.456.75-.958.75a3.69 3.69 0 0 1-.322-.017v.866c.076.017.34.027.42.027 1.108 0 1.63-.418 2.085-1.682L24 10.241h-1.155l-1.337 4.264h-.024l-1.337-4.264h-1.188Zm-1.498 2.88-.005.418c0 .665-.576 1.139-1.337 1.139-.6 0-.982-.282-.982-.716 0-.447.368-.707 1.07-.748l1.254-.093Z"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple-pay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

var _path$1e;
function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var SvgArrowDownSmall = function SvgArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.793 9.043a1 1 0 1 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-4.5-4.5a1 1 0 0 1 1.414-1.414L12 12.836Z",
    clipRule: "evenodd"
  })));
};

var _path$1d;
function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.078 6.278a1.1 1.1 0 1 0-1.556-1.556l-6.5 6.5a1.1 1.1 0 0 0 0 1.556l6.5 6.5a1.1 1.1 0 1 0 1.556-1.556L10.356 12l5.722-5.722Z",
    clipRule: "evenodd"
  })));
};

var _path$1c;
function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.022 17.722a1.1 1.1 0 1 0 1.556 1.556l6.5-6.5a1.1 1.1 0 0 0 0-1.556l-6.5-6.5a1.1 1.1 0 1 0-1.556 1.556L13.744 12l-5.722 5.722Z",
    clipRule: "evenodd"
  })));
};

var _path$1b;
function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var SvgArrowRightSmall = function SvgArrowRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.043 15.793a1 1 0 1 0 1.414 1.414l4.5-4.5a1 1 0 0 0 0-1.414l-4.5-4.5a1 1 0 0 0-1.414 1.414L12.836 12l-3.793 3.793Z",
    clipRule: "evenodd"
  })));
};

var _path$1a;
function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var SvgArrowUpSmall = function SvgArrowUpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.793 14.957a1 1 0 1 0 1.414-1.414l-4.5-4.5a1 1 0 0 0-1.414 0l-4.5 4.5a1 1 0 0 0 1.414 1.414L12 11.164Z",
    clipRule: "evenodd"
  })));
};

var _path$19;
function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.078 6.278a1.1 1.1 0 1 0-1.556-1.556l-6.5 6.5a1.1 1.1 0 0 0 0 1.556l6.5 6.5a1.1 1.1 0 1 0 1.556-1.556L10.356 12l5.722-5.722Z",
    clipRule: "evenodd"
  })));
};

var _g$2, _defs$4;
function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var SvgBlindSpotWarning = function SvgBlindSpotWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blind-spot-warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.035 16.22a.4.4 0 0 1 .325-.351.39.39 0 0 1 .414.203c.04.074.055.158.044.24a4.387 4.387 0 0 0 1.619 3.954 4.29 4.29 0 0 0 3.19.907.391.391 0 0 1 .29.083.4.4 0 0 1-.198.709 5.08 5.08 0 0 1-4.221-1.478 5.205 5.205 0 0 1-1.463-4.267Zm1.956.232a.4.4 0 0 1 .324-.35.39.39 0 0 1 .429.231c.029.067.04.14.03.213a2.39 2.39 0 0 0 .883 2.157 2.336 2.336 0 0 0 1.74.493.39.39 0 0 1 .396.199.402.402 0 0 1-.155.546.392.392 0 0 1-.15.047 3.128 3.128 0 0 1-2.598-.91 3.205 3.205 0 0 1-.899-2.626Zm13.717 1.223.008-.007.007-.008-.015.015Zm-1.427 4.288a.392.392 0 0 1-.347-.329.402.402 0 0 1 .201-.419.391.391 0 0 1 .238-.044 4.291 4.291 0 0 0 3.572-1.25 4.394 4.394 0 0 0 1.237-3.61.402.402 0 0 1 .108-.323.393.393 0 0 1 .675.23 5.191 5.191 0 0 1-1.913 4.671 5.073 5.073 0 0 1-3.77 1.074Zm.23-1.978a.393.393 0 0 1-.347-.327.403.403 0 0 1 .201-.42.391.391 0 0 1 .239-.044 2.338 2.338 0 0 0 1.948-.681c.534-.54.756-1.267.674-1.97a.402.402 0 0 1 .079-.297.398.398 0 0 1 .265-.153.39.39 0 0 1 .393.207.4.4 0 0 1 .046.15 3.197 3.197 0 0 1-1.177 2.875 3.13 3.13 0 0 1-2.32.66ZM5.107 8.905a.58.58 0 0 0 .305.507.564.564 0 0 0 .586-.036l.822-.553v7.192a1.727 1.727 0 0 0 1.393 1.695l.358.066c.887.155 2.115.32 3.367.32 1.43 0 2.832-.216 3.726-.386a1.728 1.728 0 0 0 1.393-1.695V8.823l.822.553a.565.565 0 0 0 .881-.364.581.581 0 0 0-.25-.592l-1.453-.98V4.419c0-.672-.389-1.292-1.001-1.57C15.254 2.484 13.83 2 11.938 2c-1.893 0-3.315.484-4.118.848a1.73 1.73 0 0 0-1 1.57v3.023l-1.453.979a.573.573 0 0 0-.26.485Zm3.988 4.09-1.138.737V9.674l1.138 1.125v2.197Zm-1.131-5.24V7.742c.021-.02 1.156-1.143 3.974-1.143 2.822 0 3.957 1.126 3.975 1.144v.012l-1.7 1.718h-4.55l-1.7-1.718Zm.322-3.859a8.338 8.338 0 0 1 1.946-.595v.424a1.142 1.142 0 0 1-1.137 1.15c-.486 0-.898-.31-1.061-.743a.549.549 0 0 1 .252-.236Zm.039 11.141 1.338-.966h4.55l1.339.966s-.078.083-.232.208c-.46.376-1.605 1.126-3.382 1.126-1.777 0-2.92-.75-3.382-1.126a2.518 2.518 0 0 1-.231-.208Zm6.457-10.163a1.143 1.143 0 0 1-1.138-1.15v-.423l.158.03a8.264 8.264 0 0 1 1.808.575c.1.051.179.13.233.226a1.13 1.13 0 0 1-1.06.742Zm1.137 8.858-1.137-.736v-2.197l1.137-1.125v4.058Z",
    clipRule: "evenodd"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blind-spot-warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 22V2h20v20z"
  })))));
};

var _path$18;
function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.953 2.402a.8.8 0 0 0-.753.798v7.453L7.663 8.147a.8.8 0 1 0-.926 1.306l4.01 2.84-4.1 3.929a.8.8 0 1 0 1.106 1.156l3.447-3.303V20.8a.8.8 0 0 0 1.388.542l4.8-5.2a.8.8 0 0 0-.126-1.195l-4.009-2.84 4.1-3.929a.8.8 0 0 0-.012-1.167l-4.8-4.4a.8.8 0 0 0-.588-.21Zm.847 2.617 2.831 2.593-2.831 2.713V5.019Zm0 8.728 2.795 1.98-2.795 3.028v-5.008Z"
  })));
};

var _path$17;
function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var SvgBreadcrumbSeparator = function SvgBreadcrumbSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M7.077 20.274 16.104 2.22l1.009.506-9.027 18.053-1.009-.505Z"
  })));
};

var _path$16;
function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.913 3c-.428 0-.783.326-.783.72v.72H3.783c-.454 0-.783.302-.783.72v2.52h18V5.16c0-.418-.329-.72-.783-.72H17.87v-.72c0-.394-.355-.72-.783-.72h-.783c-.428 0-.782.326-.782.72v.72H8.478v-.72c0-.394-.354-.72-.782-.72h-.783Zm0 .72h.783v2.16h-.783V3.72Zm9.391 0h.783v2.16h-.783V3.72ZM3 9.84v10.484c0 .392.329.676.783.676h16.434c.454 0 .783-.284.783-.676V9.84H3Z"
  })));
};

var _path$15, _path2$6;
function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var SvgCarPlay = function SvgCarPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.996 7.2a.4.4 0 0 0-.4.4V16.4a.4.4 0 0 0 .632.325l7.934-4.362a.401.401 0 0 0-.01-.732L9.228 7.274h-.001a.4.4 0 0 0-.232-.074Z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.89 16.732c.379.227.505.72.248 1.08a10 10 0 1 1 .052-11.55c.253.362.123.854-.258 1.078-.38.224-.868.094-1.127-.264a8.4 8.4 0 1 0-.044 9.91c.262-.356.75-.482 1.129-.255Z"
  })));
};

var _path$14;
function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var SvgCharger = function SvgCharger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.984 2.392a.8.8 0 0 0-.55.242L12 6.07 9.366 3.434a.8.8 0 1 0-1.132 1.131l3.086 3.086a.8.8 0 0 0 .232.232l4.568 4.568a.8.8 0 0 0 .232.232l3.082 3.082a.8.8 0 1 0 1.132-1.13L17.93 12l3.435-3.435a.8.8 0 1 0-1.132-1.13L16.8 10.868l-3.669-3.67 3.435-3.434a.8.8 0 0 0-.582-1.373ZM7.683 6.176 4.372 9.487a4 4 0 0 0 0 5.658l.164.164-.227.227a1.952 1.952 0 0 0 0 2.76l.132.132-1.807 1.806a.8.8 0 1 0 1.132 1.131l1.806-1.806.133.133a1.95 1.95 0 0 0 2.76 0l.227-.227.163.163a4 4 0 0 0 5.657 0l3.311-3.311-10.14-10.14ZM8 11.2a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6Zm4 4a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6Z"
  })));
};

var _path$13;
function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 2.4A1.6 1.6 0 0 0 4.8 4h13.6a2.4 2.4 0 0 1 2.4 2.4v10.4a1.6 1.6 0 0 0 1.6-1.6V4a1.6 1.6 0 0 0-1.6-1.6H6.4ZM3.2 5.6a1.6 1.6 0 0 0-1.6 1.6v11.2A1.6 1.6 0 0 0 3.2 20h2.4v2.4a.8.8 0 0 0 1.47.434L9.198 20H17.6a1.6 1.6 0 0 0 1.6-1.6V7.2a1.6 1.6 0 0 0-1.6-1.6H3.2Z"
  })));
};

var _path$12;
function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var SvgCheckboxSelected = function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1h16a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3ZM0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm18.7 4.714a1 1 0 0 0-1.4-1.428L9.84 14.6 6.7 11.52a1 1 0 0 0-1.4 1.428l3.84 3.765a1 1 0 0 0 1.4 0l8.16-8Z",
    clipRule: "evenodd"
  })));
};

var _path$11;
function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var SvgCheckboxUnselected = function SvgCheckboxUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4ZM0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
    clipRule: "evenodd"
  })));
};

var _path$10;
function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 11.557a1 1 0 0 0-1.4 1.428l1.4-1.428Zm3.78 5.106-.7.714a1 1 0 0 0 1.4 0l-.7-.714ZM19.7 8.044a1 1 0 0 0-1.4-1.428l1.4 1.428ZM4.3 12.985l4.48 4.392 1.4-1.428-4.48-4.392-1.4 1.428Zm5.88 4.392 9.52-9.333-1.4-1.428-9.52 9.333 1.4 1.428Z"
  })));
};

var _path$$;
function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var SvgCheckmarkRounded = function SvgCheckmarkRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6Zm5.366 7.766-6.048 6.048a.8.8 0 0 1-1.132 0L7.424 13.45a.8.8 0 1 1 1.131-1.131l2.197 2.197 5.482-5.483a.8.8 0 1 1 1.132 1.132Z"
  })));
};

var _path$_;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var SvgHurry = function SvgHurry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    d: "M15 20c-2.233 0-4.125-.775-5.675-2.325C7.775 16.125 7 14.233 7 12c0-2.233.775-4.125 2.325-5.675C10.875 4.775 12.767 4 15 4c2.233 0 4.125.775 5.675 2.325C22.225 7.875 23 9.767 23 12c0 2.233-.775 4.125-2.325 5.675C19.125 19.225 17.233 20 15 20Zm2.55-4.425 1.05-1.05-2.825-2.85L15.75 8h-1.5v4.3l3.3 3.275ZM2 8.75v-1.5h4v1.5H2Zm-1 4v-1.5h5v1.5H1Zm1 4v-1.5h4v1.5H2Z"
  })));
};

var _path$Z;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var SvgHighDemand = function SvgHighDemand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5A9D",
    stroke: "#2D5A9D",
    strokeWidth: 0.5,
    d: "m9.299 12.255 3.395 3.401c.11.11.232.197.366.252.13.052.27.077.414.077.142 0 .278-.025.407-.077.135-.055.257-.142.366-.251l5.95-5.95v1.572c0 .297.113.558.324.772.214.216.477.33.778.33.298 0 .558-.115.765-.333.205-.215.311-.475.311-.77v-4.27a1.076 1.076 0 0 0-1.102-1.102h-4.276a1.076 1.076 0 0 0-1.101 1.102 1.076 1.076 0 0 0 1.101 1.102h1.673l-5.171 5.176-3.402-3.401-.003-.004a1.185 1.185 0 0 0-.364-.247 1.057 1.057 0 0 0-.406-.078c-.145 0-.284.025-.414.078a1.11 1.11 0 0 0-.366.25L2.32 16.11l-.009.009c-.192.214-.295.47-.303.757l7.292-4.62Zm0 0-5.427 5.427a1.04 1.04 0 0 1-.769.306 1.072 1.072 0 0 1-.779-.332 1.034 1.034 0 0 1-.317-.78l7.292-4.62Z"
  })));
};

var _path$Y;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.29 5.289c-.46.46-.46 1.204 0 1.664l4.99 4.991-4.99 4.992A1.176 1.176 0 1 0 6.952 18.6l4.991-4.992 4.992 4.992a1.177 1.177 0 1 0 1.664-1.664l-4.992-4.992L18.6 6.953a1.176 1.176 0 1 0-1.664-1.664l-4.992 4.992-4.991-4.992a1.177 1.177 0 0 0-1.664 0Z",
    clipRule: "evenodd"
  })));
};

var _path$X;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgCloseBig = function SvgCloseBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.29 5.289c-.46.46-.46 1.204 0 1.664l4.99 4.991-4.99 4.992A1.176 1.176 0 1 0 6.952 18.6l4.991-4.992 4.992 4.992a1.177 1.177 0 1 0 1.664-1.664l-4.992-4.992L18.6 6.953a1.176 1.176 0 1 0-1.664-1.664l-4.992 4.992-4.991-4.992a1.177 1.177 0 0 0-1.664 0Z",
    clipRule: "evenodd"
  })));
};

var _path$W;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var SvgCloseRounded = function SvgCloseRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm4.279-17.704a1.009 1.009 0 0 1 1.426 1.426L13.427 12l4.278 4.279a1.009 1.009 0 0 1-1.426 1.426L12 13.426l-4.279 4.279a1.008 1.008 0 0 1-1.426-1.426L10.574 12 6.296 7.722a1.008 1.008 0 1 1 1.426-1.426l4.279 4.278 4.278-4.278Z",
    clipRule: "evenodd"
  })));
};

var _path$V;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var SvgCloseSmall = function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.754 7.246a.84.84 0 0 0-1.188 0L12 10.812 8.436 7.246a.84.84 0 0 0-1.188 1.189L10.812 12l-3.565 3.565a.84.84 0 0 0 1.188 1.189l3.566-3.565 3.565 3.565a.84.84 0 1 0 1.188-1.189L13.19 12l3.565-3.565a.84.84 0 0 0 0-1.189Z",
    clipRule: "evenodd"
  })));
};

var _path$U;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.6a1.6 1.6 0 0 0-1.6 1.6V16a1.6 1.6 0 0 0 1.6 1.6h10.4a1.6 1.6 0 0 0 1.6-1.6V6.8a.8.8 0 0 0-.234-.566l-4.4-4.4A.8.8 0 0 0 15.6 1.6H8.8Zm6.4 1.523L19.276 7.2H16a.8.8 0 0 1-.8-.8V3.123ZM4.8 5.6a1.6 1.6 0 0 0-1.6 1.6V20a1.6 1.6 0 0 0 1.6 1.6h10.4a1.6 1.6 0 0 0 1.6-1.6v-.8h-8A3.203 3.203 0 0 1 5.6 16V5.6h-.8Z"
  })));
};

var _path$T;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    d: "M3.115 4C2.223 4 1.5 4.716 1.5 5.6v.8h21v-.8c0-.884-.723-1.6-1.615-1.6H3.115ZM1.5 8.8v9.6c0 .884.723 1.6 1.615 1.6h17.77c.892 0 1.615-.716 1.615-1.6V8.8h-21Zm2.423 1.6h6.462v.8H3.923v-.8Z"
  })));
};

var _path$S, _path2$5, _path3$4;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgDiners = function SvgDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M22.5 17.867c0 1.173-.9 2.133-2 2.133h-17c-1.1 0-2-.96-2-2.133V6.133C1.5 4.96 2.4 4 3.5 4h17c1.1 0 2 .96 2 2.133v11.734Z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M14.5 8h-5c-2.2 0-4 1.8-4 4s1.8 4 4 4h5c2.2 0 4-1.8 4-4s-1.8-4-4-4Z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3Zm-2 3c0-.95.65-1.7 1.5-1.95v3.85c-.85-.2-1.5-.95-1.5-1.9Zm2.5 1.95V10.1c.85.2 1.5 1 1.5 1.95 0 .9-.65 1.65-1.5 1.9Z"
  })));
};

var _path$R, _path2$4, _path3$3, _circle;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EA",
    d: "M22.5 17.867c0 1.173-.9 2.133-2 2.133h-17c-1.1 0-2-.96-2-2.133V6.133C1.5 4.96 2.4 4 3.5 4h17c1.1 0 2 .96 2 2.133v11.734Z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D00",
    d: "M22.5 18c0 1.1-.9 2-2 2H8s11.8-1.9 14.5-7.5V18Z"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 10h.55v3H5.6v-3Zm3 1.5c0 .85.65 1.5 1.5 1.5.25 0 .45-.05.7-.15v-.65c-.2.2-.4.3-.7.3-.55 0-.95-.4-.95-1 0-.55.4-1 .95-1 .25 0 .45.1.7.3v-.65c-.25-.1-.45-.2-.7-.2-.85.05-1.5.75-1.5 1.55Zm6.7.45L14.5 10h-.6l1.25 3h.3l1.25-3h-.6l-.8 1.95ZM16.95 13h1.6v-.5H17.5v-.8h1v-.5h-1v-.7h1.05V10h-1.6v3Zm3.8-2.1c0-.55-.35-.9-1-.9h-.85v3h.55v-1.2h.05l.8 1.2h.7l-.9-1.25c.4-.1.65-.4.65-.85Zm-1.15.5h-.15v-.9h.15c.35 0 .55.15.55.45 0 .25-.15.45-.55.45ZM3.85 10H3v3h.8c1.25 0 1.55-1.05 1.55-1.5.05-.9-.6-1.5-1.5-1.5Zm-.15 2.5h-.15v-2h.2c.75 0 1.05.5 1.05 1 0 .2-.05 1-1.1 1Zm3.95-1.35c-.35-.15-.45-.2-.45-.35 0-.2.2-.3.4-.3.15 0 .3.05.45.25l.3-.4c-.25-.25-.5-.35-.85-.35-.5 0-.9.35-.9.85 0 .4.2.6.7.8.3.1.55.2.55.45s-.2.4-.45.4a.65.65 0 0 1-.6-.4l-.35.35c.25.4.55.55 1 .55.6 0 1-.4 1-.95 0-.45-.2-.65-.8-.9Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 1.5,
    fill: "#FF6D00"
  })));
};

var _path$Q;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 3.2A1.6 1.6 0 0 0 4 4.8V16a1.6 1.6 0 0 0 1.6 1.6V8c0-1.765 1.435-3.2 3.2-3.2h8a1.6 1.6 0 0 0-1.6-1.6H5.6Zm3.2 3.2A1.6 1.6 0 0 0 7.2 8v11.2a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V8a1.6 1.6 0 0 0-1.6-1.6H8.8Zm1.6 3.2h6.4a.8.8 0 0 1 0 1.6h-6.4a.8.8 0 0 1 0-1.6Zm0 3.2h6.4a.8.8 0 0 1 0 1.6h-6.4a.8.8 0 0 1 0-1.6Zm0 3.2h6.4a.8.8 0 0 1 0 1.6h-6.4a.8.8 0 0 1 0-1.6Z"
  })));
};

var _path$P;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgEndLocation = function SvgEndLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  })));
};

var _path$O;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    d: "m2.03 4.8 9.039 8.436a1.37 1.37 0 0 0 1.862 0l9.04-8.436H2.03ZM.8 5.84V19.2h22.4V5.84l-9.177 8.566A2.957 2.957 0 0 1 12 15.2a2.957 2.957 0 0 1-2.023-.794L.8 5.841Z"
  })));
};

var _path$N, _path2$3, _defs$3;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook_svg__a)",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.354 14.65h2.588l.406-2.629h-2.994v-1.437c0-1.091.357-2.06 1.378-2.06h1.642V6.23c-.289-.039-.899-.124-2.051-.124-2.408 0-3.819 1.271-3.819 4.167v1.749H8.03v2.629h2.474v7.226c.49.073.987.123 1.496.123.46 0 .91-.042 1.354-.102V14.65Z"
  })), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__a",
    x1: 4.997,
    x2: 20.308,
    y1: 4.997,
    y2: 20.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })))));
};

var _path$M;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgFuel = function SvgFuel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.2a1.6 1.6 0 0 0-1.6 1.6v14.4a.8.8 0 1 0 0 1.6h11.2a.8.8 0 1 0 0-1.6V16h2.4v2c0 1.537 1.263 2.8 2.8 2.8a.8.8 0 0 0 .29-.06c1.396-.152 2.51-1.305 2.51-2.74v-6.8a.8.8 0 0 0-.234-.566l-3.2-3.2a.794.794 0 0 0-.122-.1l-2.4-1.6a.8.8 0 1 0-.888 1.332L17.6 8.428V10.4a1.6 1.6 0 0 0 1.6 1.6h1.6v6c0 .673-.527 1.2-1.2 1.2-.673 0-1.2-.527-1.2-1.2v-2c0-.874-.726-1.6-1.6-1.6h-2.4V4.8a1.6 1.6 0 0 0-1.6-1.6h-8Zm0 1.6h8v4.8h-8V4.8Z"
  })));
};

var _path$L;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgGearbox = function SvgGearbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4A1.6 1.6 0 0 0 4 6.984v4.882a.8.8 0 0 0 0 .26v4.891a1.6 1.6 0 0 0-.331 2.514A1.6 1.6 0 1 0 5.6 17.016V12.8h5.6v4.216a1.6 1.6 0 1 0 1.6.001V12.8h5.6v6.617a1.6 1.6 0 0 0-.331 2.514A1.6 1.6 0 1 0 20 19.416v-7.282a.8.8 0 0 0 0-.26V6.982a1.6 1.6 0 0 0 .331-2.514A1.6 1.6 0 1 0 18.4 6.984V11.2h-5.6V6.983a1.6 1.6 0 0 0 .331-2.514A1.6 1.6 0 1 0 11.2 6.984V11.2H5.6V6.983a1.6 1.6 0 0 0 .331-2.514A1.6 1.6 0 0 0 4.8 4Z"
  })));
};

var _path$K;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgGenericAddress = function SvgGenericAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.6A6.4 6.4 0 0 0 5.6 8c0 4.8 5.6 6.4 5.6 9.6a.8.8 0 0 0 1.6 0c0-3.2 5.6-4.8 5.6-9.6A6.4 6.4 0 0 0 12 1.6Zm0 4.8a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Zm-7.2 7.2a.803.803 0 0 0-.75.519l-2.4 6.4A.8.8 0 0 0 2.4 21.6h19.2a.8.8 0 0 0 .75-1.081l-2.4-6.4a.803.803 0 0 0-.75-.519h-1.581c-.439.49-.891.937-1.317 1.358-.084.081-.165.162-.246.242h2.59l1.8 4.8H3.554l1.8-4.8h2.589l-.244-.242c-.427-.421-.88-.868-1.319-1.358H4.8Z"
  })));
};

var _path$J, _path2$2, _path3$2, _path4;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M21.805 10.041H21V10h-9v4h5.651A5.998 5.998 0 0 1 6 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.954 9.954 0 0 0 12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-.67-.069-1.325-.195-1.959Z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "m3.153 7.346 3.286 2.409A5.997 5.997 0 0 1 12 6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.954 9.954 0 0 0 12 2a9.994 9.994 0 0 0-8.847 5.346Z"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M12 22c2.583 0 4.93-.988 6.704-2.596l-3.095-2.619A5.955 5.955 0 0 1 12 18a5.997 5.997 0 0 1-5.641-3.973L3.098 16.54C4.753 19.777 8.114 22 12 22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M21.805 10.041H21V10h-9v4h5.651a6.02 6.02 0 0 1-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959Z"
  })));
};

var _path$I;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgHandshake = function SvgHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "m1.6 4 .013 9.6h1.271l7.032 7.352a1.6 1.6 0 0 0 2.415.18c.3-.3.469-.708.469-1.132 0-.076-.007-.152-.019-.227A1.6 1.6 0 0 0 15.2 18.4c0-.076-.007-.152-.019-.227A1.6 1.6 0 0 0 17.6 16.8c0-.076-.007-.152-.019-.227a1.6 1.6 0 0 0 1.958-2.496l-.02-.02a1.627 1.627 0 0 0-.106-.095l-4.727-4.264-4.05.643C9.516 10.518 6.4 10.146 6.4 6.4c0-1.166.86-1.425 1.406-1.625C8.352 4.575 10 4 10 4H1.6Zm13.6 0a1.6 1.6 0 0 0-.416.055h-.001l-.006.001-.005.002a1.596 1.596 0 0 0-.167.058L8 6.4v.4a2 2 0 0 0 2 2c.067 0 .13-.014.195-.02l.008.01.166-.027.047-.008 4.784-.758s4.2 3.758 4.934 4.492c.704.704 1.4 1.235 1.455 2.711H23.2V5.6l-3.2.8-3.992-2.18a1.577 1.577 0 0 0-.086-.047l-.038-.02h-.006A1.6 1.6 0 0 0 15.2 4Z"
  })));
};

var _path$H;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgHeatedSeats = function SvgHeatedSeats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 4a1.2 1.2 0 0 0-1.2 1.2c0 6.236-3.454 4.517-4 10.46 0 0-2.486-.46-4-.46-2.929 0-5.6.496-5.6 2.114 0 1.007.84 1.97.99 2.133v.001A1.2 1.2 0 0 0 6 20h8.927c1.101 0 2.061-.75 2.328-1.817l3.51-13.125-.006-.01A.8.8 0 0 0 20 4h-1.199ZM8 4.464a.485.485 0 0 0-.42.238L5.963 7.394A.4.4 0 0 0 6.306 8h.855c-.086 1.238-.354 1.858-.67 2.467C6.11 11.2 5.6 12.074 5.6 13.6a.8.8 0 1 0 1.6 0c0-1.215.29-1.588.71-2.394.36-.694.76-1.639.863-3.206h.92a.4.4 0 0 0 .345-.606L8.42 4.702A.485.485 0 0 0 8 4.464Zm4.8 0a.485.485 0 0 0-.42.238l-1.618 2.692a.4.4 0 0 0 .344.606h.855c-.086 1.238-.354 1.858-.67 2.467-.381.732-.891 1.607-.891 3.133a.8.8 0 1 0 1.6 0c0-1.215.29-1.588.71-2.394.36-.694.76-1.639.863-3.206h.92a.4.4 0 0 0 .345-.606L13.22 4.702a.485.485 0 0 0-.42-.238Z"
  })));
};

var _path$G;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6Zm.8 14.4h-1.6v-5.6h1.6v5.6ZM12 9.2a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4Z"
  })));
};

var _path$F;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgInfoBig = function SvgInfoBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6Zm.8 14.4h-1.6v-5.6h1.6v5.6ZM12 9.2a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4Z"
  })));
};

var _path$E;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgInfoSmall = function SvgInfoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.6a6.4 6.4 0 1 0 0 12.8 6.4 6.4 0 0 0 0-12.8Zm.533 9.6h-1.066v-3.733h1.066V15.2ZM12 10.133a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6Z"
  })));
};

var _path$D;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.5A5.761 5.761 0 0 0 2.5 8.25v7.5a5.762 5.762 0 0 0 5.75 5.75h7.5a5.762 5.762 0 0 0 5.75-5.75v-7.5a5.762 5.762 0 0 0-5.75-5.75h-7.5Zm0 1.5h7.5A4.239 4.239 0 0 1 20 8.25v7.5A4.24 4.24 0 0 1 15.75 20h-7.5A4.239 4.239 0 0 1 4 15.75v-7.5A4.239 4.239 0 0 1 8.25 4ZM17 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-5 1c-2.752 0-5 2.248-5 5s2.248 5 5 5 5-2.248 5-5-2.248-5-5-5Zm0 1.5c1.942 0 3.5 1.558 3.5 3.5s-1.558 3.5-3.5 3.5A3.489 3.489 0 0 1 8.5 12c0-1.942 1.558-3.5 3.5-3.5Z"
  })));
};

var _path$C;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgInvite = function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 1.6A2.412 2.412 0 0 0 8 4c0 .281.06.548.15.8H4a1.6 1.6 0 0 0-1.6 1.6V8h19.2V6.4A1.6 1.6 0 0 0 20 4.8h-4.15c.09-.252.15-.519.15-.8 0-1.316-1.084-2.4-2.4-2.4a2.38 2.38 0 0 0-1.6.63 2.38 2.38 0 0 0-1.6-.63Zm0 1.6c.452 0 .8.348.8.8v.8h-.8a.787.787 0 0 1-.8-.8c0-.452.348-.8.8-.8Zm3.2 0c.452 0 .8.348.8.8 0 .452-.348.8-.8.8h-.8V4c0-.452.348-.8.8-.8ZM3.2 9.6V20a1.6 1.6 0 0 0 1.6 1.6h6.4v-12h-8Zm9.6 0v12h6.4a1.6 1.6 0 0 0 1.6-1.6V9.6h-8Z"
  })));
};

var _path$B;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgLockAndShield = function SvgLockAndShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4c-3.682 0-7.51.83-7.51.83l-.004.003A1.6 1.6 0 0 0 3.2 4.8v4.8c0 8.318 8.017 11.795 8.017 11.795a1.6 1.6 0 0 0 1.563 0h.003S20.8 17.918 20.8 9.6V4.8a1.6 1.6 0 0 0-1.29-1.57S15.683 2.4 12 2.4Zm0 3.2c1.324 0 2.4 1.076 2.4 2.4v1.6h.8a.8.8 0 0 1 .8.8v4a.8.8 0 0 1-.8.8H8.8a.8.8 0 0 1-.8-.8v-4a.8.8 0 0 1 .8-.8h.8V8c0-1.324 1.076-2.4 2.4-2.4Zm0 1.6c-.44 0-.8.36-.8.8v1.6h1.6V8c0-.44-.36-.8-.8-.8Z"
  })));
};

var _path$A, _path2$1, _path3$1;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fill: "#5869CC",
    d: "M22.5 17.867c0 1.178-.895 2.133-2 2.133h-17c-1.104 0-2-.955-2-2.133V6.133C1.5 4.955 2.396 4 3.5 4h17c1.105 0 2 .955 2 2.133v11.734Z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M15.25 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "M11.257 15a4.992 4.992 0 0 1-.588-1h2.662a4.95 4.95 0 0 0 .319-1h-3.299a4.988 4.988 0 0 1-.101-1h3.5c0-.343-.035-.677-.1-1h-3.3c.072-.348.18-.682.319-1h2.662a4.968 4.968 0 0 0-.588-1h-1.486c.219-.29.465-.561.74-.797A4.977 4.977 0 0 0 8.75 7a5 5 0 1 0 0 10 4.985 4.985 0 0 0 3.993-2h-1.486Z"
  })));
};

var _path$z;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgMinusRounded = function SvgMinusRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm6 13H6a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2Z"
  })));
};

var _path$y;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M14.399 3.2a6.38 6.38 0 0 0-4.526 1.875L8.284 6.663c-.899.899-1.968 1.6-3.134 2.076l10.11 10.11a9.532 9.532 0 0 1 2.076-3.135l1.589-1.589a6.397 6.397 0 0 0 .927-7.866 1.6 1.6 0 1 0-2.111-2.11 6.39 6.39 0 0 0-3.342-.949ZM3.191 8.792a.8.8 0 0 0-.558 1.374l4.34 4.339A2 2 0 0 0 5.6 16.4a2 2 0 0 0 3.897.628l4.337 4.338a.8.8 0 1 0 1.132-1.132l-11.2-11.2a.8.8 0 0 0-.574-.242Z"
  })));
};

var _path$x;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.4A1.6 1.6 0 0 0 3.2 4v4.8a1.6 1.6 0 0 0 1.6 1.6h.017L14.4 12l-9.583 1.602L4.8 13.6a1.6 1.6 0 0 0-1.6 1.6V20a1.6 1.6 0 0 0 2.394 1.387h.001l16.318-8.65.001-.003a.801.801 0 0 0-.002-1.472L5.596 2.612A1.6 1.6 0 0 0 4.8 2.4Z"
  })));
};

var _g$1, _defs$2;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#people_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 3.2a4 4 0 0 0-4 4V8a4 4 0 0 0 8 0v-.8a4 4 0 0 0-4-4Zm9.6 0a4 4 0 0 0-4 4V8a4 4 0 0 0 8 0v-.8a4 4 0 0 0-4-4Zm0 1.6c1.323 0 2.4 1.077 2.4 2.4V8c0 1.323-1.077 2.4-2.4 2.4A2.403 2.403 0 0 1 14.4 8v-.8c0-1.323 1.077-2.4 2.4-2.4Zm-9.602 8.8c-2.622 0-5.986 1.5-6.954 3.131-.598 1.008-.029 2.469.953 2.469h21.606c.982 0 1.552-1.46.953-2.469-.968-1.632-4.335-3.131-6.958-3.131-1.56 0-3.373.537-4.798 1.31-1.425-.773-3.24-1.31-4.802-1.31Zm9.6 1.6c2.216 0 4.968 1.313 5.582 2.347a.148.148 0 0 1 .015.053h-8.001a1.778 1.778 0 0 0-.24-.869c-.157-.265-.396-.524-.666-.776 1.025-.44 2.23-.755 3.31-.755Z"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "people_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

var _path$w;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgPhoneMount = function SvgPhoneMount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.846 2.31H7.154c-.765 0-1.385.62-1.385 1.385V20.31c0 .765.62 1.385 1.385 1.385h9.692c.765 0 1.385-.62 1.385-1.385V3.695c0-.765-.62-1.385-1.385-1.385Zm-3.115.692a.346.346 0 1 1 0 .693.346.346 0 0 1 0-.693Zm-2.77 0h1.385a.346.346 0 0 1 0 .693h-1.384a.346.346 0 0 1 0-.693Zm5.885 17.308H7.154V3.695H9.23l.286.286c.26.26.612.406.98.406h3.006c.367 0 .72-.146.979-.406l.287-.286h2.077V20.31ZM3 7.849a.692.692 0 0 1 1.385 0v8.307a.692.692 0 0 1-1.385 0V7.85Zm17.308-.693a.692.692 0 0 0-.693.692v8.308a.692.692 0 1 0 1.385 0V7.85a.692.692 0 0 0-.692-.693Z",
    clipRule: "evenodd"
  })));
};

var _path$v;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 4a1.6 1.6 0 0 0-1.6 1.6v12.8A1.6 1.6 0 0 0 3.2 20h17.6a1.6 1.6 0 0 0 1.6-1.6V5.6A1.6 1.6 0 0 0 20.8 4H3.2Zm15.2 2.4a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2ZM7.2 10.402c.495 0 .99.189 1.369.567l2.61 2.61.821.821.925.925a.866.866 0 0 0 1.22-1.228l-.922-.92.608-.608a1.935 1.935 0 0 1 2.738 0L20 16v1.6H4v-4.8l1.831-1.831a1.93 1.93 0 0 1 1.369-.567Z"
  })));
};

var _path$u;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 3.096a7.258 7.258 0 0 0-7.258 7.258c0 4.773 4.719 7.058 5.31 7.59.604.542 1.102 1.76 1.304 2.45a.685.685 0 0 0 .644.512.686.686 0 0 0 .644-.512c.2-.69.7-1.907 1.303-2.45.592-.532 5.31-2.817 5.31-7.59a7.258 7.258 0 0 0-7.257-7.258Zm0 9.237a1.98 1.98 0 1 1 0-3.959 1.98 1.98 0 0 1 0 3.959Z"
  })));
};

var _path$t;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgPlusRounded = function SvgPlusRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm6 13h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 1 1 2 0v5h5a1 1 0 1 1 0 2Z"
  })));
};

var _path$s;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 2.4a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm7.988.79A.8.8 0 0 0 12.8 4H9.6v1.6h3.866a.8.8 0 0 0 .26 0H19.2v8h-3.873a.79.79 0 0 0-.264 0h-2.93a.788.788 0 0 0-.266 0H9.6v1.6h1.375l-1.352 5.406a.8.8 0 1 0 1.554.388l1.448-5.794h1.95l1.448 5.794a.802.802 0 0 0 1.463.218.8.8 0 0 0 .09-.606L16.226 15.2H20a.8.8 0 0 0 .8-.8V4.8A.8.8 0 0 0 20 4h-5.6a.798.798 0 0 0-.813-.81ZM4.8 8.8a1.6 1.6 0 0 0-1.6 1.6v10.373a.827.827 0 0 0 1.652.055l.35-5.255a.4.4 0 0 1 .796-.001l.35 5.256A.827.827 0 0 0 8 20.773V11.2a.8.8 0 0 1 .8-.8h4a.8.8 0 1 0 0-1.6h-8Z"
  })));
};

var _path$r;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.2a1.6 1.6 0 0 0-1.6 1.6v14.4a1.6 1.6 0 0 0 1.6 1.6h1.245a3.167 3.167 0 0 1-.445-1.6V4.8c0-.586.17-1.127.445-1.6H4.8Zm4 0a1.6 1.6 0 0 0-1.6 1.6v14.4a1.6 1.6 0 0 0 1.6 1.6h10.4a1.6 1.6 0 0 0 1.6-1.6V4.8a1.6 1.6 0 0 0-1.6-1.6H8.8ZM14 6.4c1.765 0 3.2 1.435 3.2 3.2 0 1.372-.857 2.163-1.545 2.8-.53.489-.855.81-.855 1.2h-1.6c0-1.111.76-1.813 1.369-2.377.639-.59 1.031-.984 1.031-1.623 0-.882-.718-1.6-1.6-1.6-.882 0-1.6.718-1.6 1.6h-1.6c0-1.765 1.435-3.2 3.2-3.2Zm.003 9.319c.747 0 1.197.4 1.197 1.087 0 .675-.45 1.075-1.197 1.075-.754 0-1.203-.4-1.203-1.075 0-.686.45-1.087 1.203-1.087Z"
  })));
};

var _path$q;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgRadioButtonSelected = function SvgRadioButtonSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm1 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6Z",
    clipRule: "evenodd"
  })));
};

var _path$p;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgRadioButtonUnselected = function SvgRadioButtonUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm1 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z",
    clipRule: "evenodd"
  })));
};

var _path$o;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgRoad = function SvgRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.2a1.6 1.6 0 0 0-1.575 1.323l-.002.002-2.398 14.39h.002A1.6 1.6 0 0 0 4 20.8h7.2v-3.999h1.6v4H20a1.6 1.6 0 0 0 1.573-1.884l.002-.002-2.398-14.386v-.003h-.002A1.6 1.6 0 0 0 17.6 3.2h-4.8v1.6h-1.6V3.2H6.4Zm4.8 3.2h1.6v2.4h-1.6V6.4Zm0 4h1.6v4h-1.6v-4Z"
  })));
};

var _path$n;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.453 10.726a5.727 5.727 0 1 1-11.453 0 5.727 5.727 0 0 1 11.453 0Zm-1.016 6.126a7.727 7.727 0 1 1 1.414-1.414l3.855 3.853a1 1 0 0 1-1.415 1.415l-3.854-3.854Z",
    clipRule: "evenodd"
  })));
};

var _path$m;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 2a.998.998 0 0 0-.98.809l-.334 1.714c-.821.31-1.58.744-2.246 1.291l-1.645-.566a1 1 0 0 0-1.191.445L2.586 8.307c-.24.415-.152.941.209 1.255l1.318 1.147A8.01 8.01 0 0 0 4 12c0 .44.045.87.113 1.291l-1.318 1.146c-.361.315-.448.841-.21 1.256l1.509 2.614a1 1 0 0 0 1.191.447l1.645-.567a7.986 7.986 0 0 0 2.246 1.29l.334 1.714c.092.47.501.809.98.809h3.02a.998.998 0 0 0 .98-.809l.334-1.714c.821-.31 1.58-.744 2.246-1.291l1.645.566a1 1 0 0 0 1.191-.445l1.508-2.616a1 1 0 0 0-.209-1.254l-1.318-1.146c.068-.421.113-.85.113-1.291 0-.44-.045-.87-.113-1.291l1.318-1.146c.361-.315.448-.841.21-1.256l-1.509-2.614a1 1 0 0 0-1.191-.447l-1.645.566a7.984 7.984 0 0 0-2.246-1.289L14.49 2.81A.998.998 0 0 0 13.51 2h-3.02ZM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
  })));
};

var _path$l, _defs$1;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__a)",
    d: "m12.457 2.593 2.738 6.144 6.69.706a.5.5 0 0 1 .281.869l-4.996 4.502 1.395 6.58a.5.5 0 0 1-.739.538L12 18.57l-5.827 3.361a.5.5 0 0 1-.739-.537l1.396-6.58-4.997-4.503a.5.5 0 0 1 .282-.868l6.69-.707 2.739-6.144a.5.5 0 0 1 .912 0Z"
  })), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star_svg__a",
    x1: 4.504,
    x2: 19.046,
    y1: 3.18,
    y2: 22.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB705"
  })))));
};

var _g, _defs;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgSuitcase = function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#suitcase_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.6 4a.8.8 0 0 1 .8-.8h3.2a.8.8 0 0 1 .8.8v.8h6.4a1.6 1.6 0 0 1 1.6 1.6v12.8a1.6 1.6 0 0 1-1.6 1.6h-1.3v-16h-1v16h-13v-16h-1v16H3.2a1.6 1.6 0 0 1-1.6-1.6V6.4a1.6 1.6 0 0 1 1.6-1.6h6.4V4Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "suitcase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 22V2h20v20z"
  })))));
};

var _path$k;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgSurfer = function SvgSurfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M14.795 2.397a.4.4 0 0 0-.247.092l-3.956 3.194a.4.4 0 0 0 .044.653l.948.577-2.087 1.045-2.77-.616c-.179-.07-.37-.11-.57-.126a.8.8 0 0 0-.152-.016H6l-.01.002a.8.8 0 0 0-.148.014A1.994 1.994 0 0 0 4 9.2v4c0 .731.396 1.364.981 1.713a.795.795 0 0 0 .14.128l3.01 2.257c-.308.254-.606.487-.926.768.233-.084.425-.165.532-.218a2.423 2.423 0 0 1 2.136.005c.305.148 1.303.547 2.127.547.824 0 1.822-.398 2.137-.552a2.423 2.423 0 0 1 2.136.005c.044.02.106.049.175.078.668-.599 1.205-1.124 1.368-1.289.8-.813 1.382-1.54 1.382-2.505 0-.674-.742-1.337-1.785-1.337-1.159 0-2.718.361-4.665 1.36l-2.668-2a.8.8 0 0 0-.374-.152L8 11.59V9.6h1.586a.8.8 0 0 0 .372-.084l3.2-1.6a.812.812 0 0 0 .039-.022l1.395.848a.4.4 0 0 0 .461-.031l4.872-3.964a.4.4 0 1 0-.505-.622l-4.653 3.786-1.158-.703a.8.8 0 0 0-1.167-.724l-.012.007-.893-.543 3.515-2.837a.4.4 0 0 0-.257-.714ZM6 2.4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2.863 11.447 2.356 1.192a27.1 27.1 0 0 0-1.806 1.247.81.81 0 0 0-.057-.061l-1.648-1.998.019-.035 1.136-.345Zm-6.491 5.348a.8.8 0 0 0-.33 1.52s1.691.885 3.558.885c1.557 0 2.767-.533 3.2-.738.433.205 1.643.738 3.2.738 1.557 0 2.767-.533 3.2-.738.433.205 1.643.738 3.2.738 1.867 0 3.558-.884 3.558-.884a.8.8 0 1 0-.716-1.432S19.733 20 18.4 20c-1.333 0-2.842-.716-2.842-.716a.8.8 0 0 0-.716 0S13.333 20 12 20c-1.333 0-2.842-.716-2.842-.716a.8.8 0 0 0-.716 0S6.933 20 5.6 20c-1.333 0-2.842-.716-2.842-.716a.8.8 0 0 0-.386-.089Z"
  })));
};

var _path$j;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 1.989a.8.8 0 0 0-.788.811v.4H6.8a.8.8 0 0 0-.811.8H4.8a.8.8 0 1 0 0 1.6h14.4a.8.8 0 1 0 0-1.6h-1.19a.8.8 0 0 0-.81-.8h-4.4v-.4a.802.802 0 0 0-.813-.81ZM4.8 7.2l1.434 12.188A1.598 1.598 0 0 0 7.822 20.8h8.356c.811 0 1.492-.607 1.588-1.413L19.2 7.2H4.8Z"
  })));
};

var _path$i;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 5.55a8.519 8.519 0 0 1-2.451.672 4.275 4.275 0 0 0 1.876-2.361 8.557 8.557 0 0 1-2.71 1.036 4.268 4.268 0 0 0-7.271 3.891 12.115 12.115 0 0 1-8.797-4.46 4.257 4.257 0 0 0-.577 2.147c0 1.48.753 2.787 1.898 3.551a4.259 4.259 0 0 1-1.933-.533v.053a4.268 4.268 0 0 0 3.423 4.184 4.269 4.269 0 0 1-1.927.074 4.273 4.273 0 0 0 3.987 2.964 8.559 8.559 0 0 1-6.319 1.767 12.081 12.081 0 0 0 6.542 1.917c7.85 0 12.14-6.502 12.14-12.142 0-.184-.003-.368-.011-.552A8.684 8.684 0 0 0 22.4 5.55Z"
  })));
};

var _path$h;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4a4.8 4.8 0 0 0-4.8 4.8V8a4.8 4.8 0 1 0 9.6 0v-.8A4.8 4.8 0 0 0 12 2.4Zm-.002 12.8c-3.204 0-7.316 1.733-8.5 3.272-.73.951-.035 2.328 1.165 2.328h14.673c1.2 0 1.895-1.377 1.164-2.328-1.183-1.538-5.297-3.272-8.502-3.272Z"
  })));
};

var _path$g, _path2, _path3;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M22.5 17.867c0 1.178-.895 2.133-2 2.133h-17c-1.104 0-2-.955-2-2.133V6.133C1.5 4.955 2.396 4 3.5 4h17c1.105 0 2 .955 2 2.133v11.734Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.593 9.25 6.28 13.167s-.334-1.656-.367-1.864c-.747-1.705-1.85-1.61-1.85-1.61l1.3 5.059v-.002h1.58L9.13 9.252H7.593Zm1.251 5.5h1.436l.868-5.5H9.694l-.85 5.5Zm10.16-5.5h-1.51l-2.355 5.5h1.425l.294-.785h1.799l.152.786h1.307l-1.112-5.5Zm-1.748 3.665.782-2.079.409 2.079h-1.19Zm-4.072-2.061c0-.303.25-.529.964-.529.463 0 .995.337.995.337l.233-1.155s-.679-.257-1.345-.257c-1.51 0-2.289.722-2.289 1.636 0 1.653 1.99 1.427 1.99 2.276 0 .145-.115.481-.944.481-.831 0-1.38-.304-1.38-.304l-.247 1.108s.532.303 1.559.303c1.029 0 2.457-.77 2.457-1.876 0-1.33-1.992-1.427-1.992-2.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M6.106 12.223 5.623 9.85s-.219-.514-.787-.514h-2.22s2.831.836 3.49 2.888Z"
  })));
};

var _path$f;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 3.2a2.412 2.412 0 0 0-2.4 2.4v12.8a2.4 2.4 0 0 0 2.4 2.4h13.6a1.6 1.6 0 0 0 1.6-1.6V8a1.6 1.6 0 0 0-1.6-1.6H5.6a.787.787 0 0 1-.8-.8c0-.452.348-.8.8-.8h12a.8.8 0 1 0 0-1.6h-12Zm12 8.8a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Z"
  })));
};

var _path$e;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4a1.6 1.6 0 0 0-1.477.983L1.841 18.358v.001a1.6 1.6 0 0 0 .228 1.972 1.6 1.6 0 0 0 1.244.464l.003.005h17.368l.003-.006a1.6 1.6 0 0 0 1.472-2.436l-.012-.022-.002-.002-8.668-14.951A1.6 1.6 0 0 0 12 2.4Zm-.97 6.687h1.94l-.16 5.179h-1.62l-.16-5.179Zm.973 6.761c.658 0 1.052.354 1.052.958 0 .593-.394.946-1.052.946-.662 0-1.06-.353-1.06-.946 0-.604.397-.958 1.06-.958Z"
  })));
};

var _path$d;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgYelp = function SvgYelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2C00",
    d: "M5.35 16.35c-.25 0-.45-.15-.6-.4-.1-.2-.15-.5-.2-.85-.1-1.1 0-2.75.35-3.25.15-.25.4-.35.6-.35.15 0 .3.05 3.55 1.4l.95.4c.35.15.55.5.55.9s-.25.7-.6.8l-1.35.45c-3 .9-3.1.9-3.25.9Zm6.65 1.8c0 3.15 0 3.25-.05 3.4-.1.25-.3.4-.55.45-.8.15-3.3-.8-3.85-1.4-.1-.15-.15-.25-.2-.4 0-.1 0-.2.05-.3.05-.15.15-.3 2.4-2.95l.65-.8c.2-.3.65-.35 1-.25.35.15.6.45.55.8v1.45Zm-.6-6.7c-.15.05-.65.2-1.25-.8 0 0-4.05-6.45-4.15-6.65-.05-.2 0-.5.2-.7.6-.65 3.85-1.55 4.7-1.35.3.05.45.25.55.5.05.3.45 6.25.5 7.6.1 1.2-.4 1.35-.55 1.4Zm2.2 1.5c-.2-.3-.2-.7 0-.95l.85-1.15c1.8-2.5 1.9-2.65 2.05-2.7.2-.15.45-.15.7-.05.7.35 2.2 2.55 2.3 3.35v.05c0 .3-.1.5-.3.65-.15.1-.25.15-3.7.95-.55.15-.85.2-1 .25v-.05c-.3.15-.7-.05-.9-.35Zm5.85 4.25c-.1.8-1.75 2.9-2.55 3.2-.25.1-.5.1-.7-.1-.15-.1-.25-.3-2.05-3.2l-.55-.85c-.2-.3-.15-.7.1-1.05.25-.3.6-.4.95-.3l1.35.45c3 1 3.1 1 3.2 1.1.2.25.3.5.25.75Z"
  })));
};

var _path$c;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgArrowRightRounded = function SvgArrowRightRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.399c-5.302 0-9.6 4.298-9.6 9.6 0 5.301 4.298 9.6 9.6 9.6s9.6-4.299 9.6-9.6c0-5.302-4.298-9.6-9.6-9.6Zm4.566 10.166-3.2 3.2a.798.798 0 0 1-1.132 0 .8.8 0 0 1 0-1.132L14.07 12.8H8a.8.8 0 1 1 0-1.6h6.069l-1.835-1.834a.8.8 0 1 1 1.132-1.132l3.2 3.2a.8.8 0 0 1 0 1.132Z"
  })));
};

var _path$b;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgCarWithKey = function SvgCarWithKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.6a3.2 3.2 0 0 0 0 6.4 3.186 3.186 0 0 0 2.756-1.6H13.6l.8-.8.8.8.8-.8.8.8h.8l.8-.8V4l-.8-.8h-6.044A3.186 3.186 0 0 0 8.8 1.6ZM8 4a.8.8 0 1 1 0 1.6A.8.8 0 0 1 8 4Zm.645 5.6a2.406 2.406 0 0 0-2.272 1.627L5.36 14.198A2.39 2.39 0 0 0 4 16.353V21.2a1.2 1.2 0 0 0 2.4 0v-.59c1.39.097 3.295.19 5.6.19 2.305 0 4.21-.093 5.6-.19v.59a1.2 1.2 0 0 0 2.4 0V16.353a2.39 2.39 0 0 0-1.36-2.155l-1.013-2.971A2.406 2.406 0 0 0 15.355 9.6h-6.71Zm0 1.6h6.71c.345 0 .646.215.758.542l.712 2.094A45.003 45.003 0 0 0 12 13.6c-2.009 0-3.603.104-4.825.236l.713-2.094a.796.796 0 0 1 .757-.542ZM6.8 16a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Zm10.4 0a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z"
  })));
};

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.145 11.586c.069-.112 3.91-6.253 9.855-6.253s9.786 6.141 9.855 6.253l.002.001a.667.667 0 0 1 .035.776l-.008.013c-.04.077-3.258 6.29-9.884 6.29-6.654 0-9.878-6.275-9.89-6.299l-.002-.004a.667.667 0 0 1 .037-.777ZM16.667 12a4.667 4.667 0 1 0-9.334 0 4.667 4.667 0 0 0 9.334 0ZM12 14.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334Z",
    clipRule: "evenodd"
  })));
};

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgEyeCrossed = function SvgEyeCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "m3.138 2.195-.943.943 18.667 18.667.943-.943-4.017-4.017c2.73-1.849 4.078-4.434 4.096-4.469a.667.667 0 0 0-.029-.79c-.069-.112-3.91-6.253-9.855-6.253-1.687 0-3.2.5-4.51 1.214L3.138 2.195ZM12 7.333A4.667 4.667 0 0 1 16.667 12a4.622 4.622 0 0 1-.938 2.787l-1.436-1.437c.236-.395.374-.855.374-1.35A2.667 2.667 0 0 0 12 9.333c-.495 0-.955.138-1.35.374L9.214 8.271A4.622 4.622 0 0 1 12 7.333Zm-6.7.718c-1.98 1.666-3.117 3.474-3.154 3.534a.667.667 0 0 0-.035.782c.011.024 3.235 6.3 9.889 6.3a10.02 10.02 0 0 0 3.346-.57l-1.725-1.726a4.64 4.64 0 0 1-1.621.296A4.667 4.667 0 0 1 7.333 12c0-.57.108-1.115.296-1.621L5.3 8.05Zm4.041 4.023a2.659 2.659 0 0 0 2.584 2.585L9.34 12.074Z"
  })));
};

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    fill: "none"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M11.767 20.933v-7.566l1.9-5.6a.799.799 0 0 1 .266-.4c.133-.111.322-.167.567-.167h10.1c.244 0 .428.05.55.15.122.1.216.239.283.417l1.9 5.6v7.566c0 .2-.072.373-.216.517a.706.706 0 0 1-.517.217h-.734a.706.706 0 0 1-.516-.217.705.705 0 0 1-.217-.517v-1.5H13.967v1.5c0 .2-.073.373-.217.517a.705.705 0 0 1-.517.217H12.5a.705.705 0 0 1-.517-.217.705.705 0 0 1-.216-.517Zm1.766-8.566h12.034L24.3 8.533h-9.5l-1.267 3.834Zm1.8 4.866c.378 0 .69-.122.934-.366.244-.245.366-.556.366-.934 0-.377-.122-.689-.366-.933-.245-.244-.556-.367-.934-.367s-.689.123-.933.367c-.245.244-.367.556-.367.933 0 .378.122.69.367.934.244.244.555.366.933.366Zm8.434 0c.377 0 .688-.122.933-.366.244-.245.367-.556.367-.934 0-.377-.123-.689-.367-.933-.245-.244-.556-.367-.933-.367-.378 0-.69.123-.934.367-.244.244-.366.556-.366.933 0 .378.122.69.366.934.245.244.556.366.934.366Zm-20.3 4.434v-.7l1.9-1.9c-1.245 0-2.34-.417-3.284-1.25-.944-.834-1.416-1.784-1.416-2.85V4.033c0-1.466.577-2.45 1.733-2.95 1.155-.5 3.444-.75 6.867-.75 3.177 0 5.405.273 6.683.817 1.278.544 1.916 1.506 1.916 2.883V6.2h-2V3.633h-13.2V12.6h8.1v9.067h-7.3Zm.9-5.4c.377 0 .688-.123.933-.367.244-.244.367-.556.367-.933 0-.378-.123-.69-.367-.934-.245-.244-.556-.366-.933-.366-.378 0-.69.122-.934.366-.244.245-.366.556-.366.934 0 .377.122.689.366.933.245.244.556.367.934.367Z"
  })));
};

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgAddAdditionalDriver = function SvgAddAdditionalDriver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M15 27.5c-1.708 0-3.323-.328-4.844-.984a12.679 12.679 0 0 1-3.984-2.688 12.679 12.679 0 0 1-2.688-3.984A12.096 12.096 0 0 1 2.5 15c0-1.73.328-3.354.984-4.875a12.492 12.492 0 0 1 2.688-3.969 12.814 12.814 0 0 1 3.984-2.672A12.096 12.096 0 0 1 15 2.5c.958 0 1.88.104 2.766.313.885.208 1.734.5 2.547.874v2.094a10.445 10.445 0 0 0-2.516-1.047c-.886-.24-1.818-.359-2.797-.359-2.938 0-5.443 1.031-7.516 3.094C5.411 9.53 4.375 12.042 4.375 15c0 2.938 1.036 5.443 3.11 7.516 2.072 2.073 4.577 3.109 7.515 3.109 2.958 0 5.469-1.037 7.531-3.11 2.063-2.072 3.094-4.578 3.094-7.515 0-.73-.068-1.432-.203-2.11a9.665 9.665 0 0 0-.61-1.953h2A11.91 11.91 0 0 1 27.5 15c0 1.708-.328 3.323-.984 4.844a12.812 12.812 0 0 1-2.672 3.984 12.492 12.492 0 0 1-3.969 2.688c-1.52.656-3.146.984-4.875.984Zm4.563-14.156c.479 0 .88-.162 1.203-.485.323-.322.484-.724.484-1.203 0-.479-.162-.88-.484-1.203a1.633 1.633 0 0 0-1.203-.484c-.48 0-.88.161-1.204.484a1.634 1.634 0 0 0-.484 1.203c0 .48.162.88.484 1.203.323.323.724.485 1.203.485Zm-9.125 0c.479 0 .88-.162 1.203-.485.322-.322.484-.724.484-1.203 0-.479-.162-.88-.484-1.203a1.633 1.633 0 0 0-1.204-.484c-.479 0-.88.161-1.203.484a1.634 1.634 0 0 0-.484 1.203c0 .48.161.88.484 1.203.323.323.724.485 1.204.485Zm4.562 8.5c1.375 0 2.64-.37 3.797-1.11a6.362 6.362 0 0 0 2.515-3.015H8.688a6.575 6.575 0 0 0 2.532 3.015A6.83 6.83 0 0 0 15 21.844ZM25.313 8.75V5.937H22.5V4.063h2.813V1.25h1.875v2.813H30v1.875h-2.813V8.75h-1.875Z"
  })));
};

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgAdditionalDriver = function SvgAdditionalDriver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M15 17.5c.688 0 1.276-.245 1.766-.734.49-.49.734-1.078.734-1.766s-.245-1.276-.734-1.766A2.407 2.407 0 0 0 15 12.5c-.688 0-1.276.245-1.766.734A2.407 2.407 0 0 0 12.5 15c0 .688.245 1.276.734 1.766.49.49 1.079.734 1.766.734Zm-5 5h10v-.719a2.492 2.492 0 0 0-1.531-2.313 9.457 9.457 0 0 0-1.672-.53A8.409 8.409 0 0 0 15 18.75c-.625 0-1.224.063-1.797.188a9.457 9.457 0 0 0-1.672.53A2.492 2.492 0 0 0 10 21.782v.719Zm13.125 5H6.875c-.5 0-.938-.188-1.313-.563-.375-.375-.562-.812-.562-1.312V4.375c0-.5.188-.938.563-1.313.375-.374.812-.562 1.312-.562h10.656L25 9.969v15.656c0 .5-.188.938-.563 1.313-.375.375-.812.562-1.312.562Zm0-1.875V10.812l-6.438-6.437H6.876v21.25h16.25Zm-16.25 0V4.375v21.25Z"
  })));
};

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgGuarantee = function SvgGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M15 26.25c-2.854 0-5.234-1.01-7.14-3.031C5.952 21.198 5 18.812 5 16.062V6.25c0-.5.188-.938.563-1.313.375-.375.812-.562 1.312-.562h15.938c.5 0 .937.188 1.312.563.375.375.563.812.563 1.312v2.813c0 .291-.053.567-.157.828-.104.26-.26.494-.468.703l-7.22 7.219c-.416.416-.931.625-1.546.625s-1.13-.209-1.547-.625L10.437 14.5l1.313-1.344 3.563 3.531 7.5-7.5V6.25H6.874v9.813c0 2.229.781 4.166 2.344 5.812 1.562 1.646 3.49 2.469 5.781 2.469 2.208 0 4.094-.756 5.656-2.266 1.563-1.51 2.386-3.349 2.469-5.515H25c-.083 2.708-1.083 5-3 6.875s-4.25 2.812-7 2.812Z"
  })));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M11 24c-3.044 0-5.583-1.077-7.617-3.233-2.033-2.156-3.05-4.7-3.05-7.633V2.667c0-.533.2-1 .6-1.4.4-.4.867-.6 1.4-.6h17c.534 0 1 .2 1.4.6.4.4.6.867.6 1.4v3c0 .311-.055.606-.166.883a2.22 2.22 0 0 1-.5.75l-7.7 7.7c-.445.445-.995.667-1.65.667-.656 0-1.206-.222-1.65-.667l-3.534-3.533 1.4-1.433 3.8 3.766 8-8V2.667h-17v10.467c0 2.377.834 4.444 2.5 6.2C6.5 21.089 8.556 21.967 11 21.967c2.356 0 4.367-.806 6.033-2.417 1.667-1.61 2.545-3.572 2.634-5.883h2c-.09 2.889-1.156 5.333-3.2 7.333-2.045 2-4.534 3-7.467 3Z"
  })));
};

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M16 0c2.633 0 4.875.925 6.725 2.775C24.575 4.625 25.5 6.867 25.5 9.5v4.8H29c.833 0 1.542.292 2.125.875S32 16.467 32 17.3V39c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 29 42H3a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 0 39V17.3c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 3 14.3h3.5V9.5c0-2.633.925-4.875 2.775-6.725C11.125.925 13.367 0 16 0Zm0 3c-1.8 0-3.333.633-4.6 1.9-1.267 1.267-1.9 2.8-1.9 4.6v4.8h13V9.5c0-1.8-.633-3.333-1.9-4.6C19.333 3.633 17.8 3 16 3ZM3 39h26V17.3H3V39Zm13-14.7c-1.067 0-1.975.408-2.725 1.225-.75.817-1.125 1.725-1.125 2.725 0 1.033.375 1.917 1.125 2.65.75.733 1.658 1.1 2.725 1.1 1.067 0 1.975-.367 2.725-1.1.75-.733 1.125-1.617 1.125-2.65 0-1-.375-1.908-1.125-2.725-.75-.817-1.658-1.225-2.725-1.225Zm-13-7V39 17.3Z"
  })));
};

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M6.5 9.5c0-2.633.925-4.875 2.775-6.725C11.125.925 13.367 0 16 0s4.875.925 6.725 2.775C24.575 4.625 25.5 6.867 25.5 9.5v4.8H29c.833 0 1.542.292 2.125.875S32 16.467 32 17.3V39c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 29 42H3a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 0 39V17.3c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 3 14.3h19.5V9.5c0-1.8-.633-3.333-1.9-4.6C19.333 3.633 17.8 3 16 3c-1.8 0-3.333.633-4.6 1.9-1.267 1.267-1.9 2.8-1.9 4.6h-3ZM3 39h26V17.3H3V39Zm13-14.7c-1.067 0-1.975.408-2.725 1.225-.75.817-1.125 1.725-1.125 2.725 0 1.033.375 1.917 1.125 2.65.75.733 1.658 1.1 2.725 1.1 1.067 0 1.975-.367 2.725-1.1.75-.733 1.125-1.617 1.125-2.65 0-1-.375-1.908-1.125-2.725-.75-.817-1.658-1.225-2.725-1.225Zm-13-7V39 17.3Z"
  })));
};

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgSharedTrip = function SvgSharedTrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#046720",
    d: "M12.625 19.5c-1.583 0-2.938-.563-4.063-1.688-1.125-1.125-1.687-2.493-1.687-4.104 0-1.583.562-2.937 1.687-4.062 1.125-1.125 2.48-1.688 4.063-1.688 1.611 0 2.98.563 4.104 1.688 1.125 1.125 1.688 2.479 1.688 4.062 0 1.611-.563 2.98-1.688 4.104-1.125 1.125-2.493 1.688-4.104 1.688Zm0-2.792c.833 0 1.542-.292 2.125-.875a2.893 2.893 0 0 0 .875-2.125c0-.833-.292-1.542-.875-2.125a2.893 2.893 0 0 0-2.125-.875c-.833 0-1.542.292-2.125.875a2.893 2.893 0 0 0-.875 2.125c0 .833.292 1.542.875 2.125a2.893 2.893 0 0 0 2.125.875Zm12.25 4.625c-1.195 0-2.216-.424-3.063-1.271s-1.27-1.867-1.27-3.062c0-1.195.423-2.215 1.27-3.062s1.868-1.271 3.063-1.271c1.222 0 2.25.424 3.083 1.271.833.847 1.25 1.867 1.25 3.062 0 1.195-.417 2.215-1.25 3.062s-1.861 1.271-3.083 1.271Zm-10.417 9.334c1.306-2.5 2.994-4.188 5.063-5.063 2.07-.875 3.854-1.312 5.354-1.312.639 0 1.243.049 1.813.146.57.097 1.146.228 1.729.395.694-1.027 1.277-2.222 1.75-3.583.472-1.361.708-2.778.708-4.25 0-3.889-1.34-7.173-4.021-9.854-2.68-2.68-5.965-4.021-9.854-4.021-3.889 0-7.173 1.34-9.854 4.021-2.68 2.68-4.021 5.965-4.021 9.854 0 1.361.188 2.674.563 3.938.375 1.263.91 2.409 1.604 3.437 1.083-.555 2.257-1 3.52-1.333 1.264-.333 2.535-.5 3.813-.5a14.207 14.207 0 0 1 4.458.708c-.555.305-1.076.639-1.562 1s-.937.736-1.354 1.125a9.037 9.037 0 0 0-.813-.042h-.729c-.917 0-1.889.118-2.917.355-1.027.236-1.944.548-2.75.937 1 1.055 2.146 1.937 3.438 2.646a12.4 12.4 0 0 0 4.062 1.396Zm2.542 3c-2.278 0-4.43-.438-6.458-1.313a16.898 16.898 0 0 1-5.313-3.583 16.965 16.965 0 0 1-3.583-5.292C.771 21.465.333 19.305.333 17c0-2.305.438-4.465 1.313-6.479a16.965 16.965 0 0 1 3.583-5.292 16.965 16.965 0 0 1 5.292-3.583C12.535.771 14.695.333 17 .333c2.305 0 4.465.438 6.479 1.313a16.965 16.965 0 0 1 5.292 3.583 16.965 16.965 0 0 1 3.583 5.292c.875 2.014 1.313 4.174 1.313 6.479 0 2.278-.438 4.43-1.313 6.458a16.898 16.898 0 0 1-3.583 5.313 16.965 16.965 0 0 1-5.292 3.583c-2.014.875-4.174 1.313-6.479 1.313Z"
  })));
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgShareLocation = function SvgShareLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M12.975 21.95v-2c.7-.1 1.379-.292 2.037-.575a9.228 9.228 0 0 0 1.863-1.075l1.45 1.45a10.768 10.768 0 0 1-2.525 1.488c-.9.375-1.842.612-2.825.712Zm6.75-3.65-1.4-1.4a7.396 7.396 0 0 0 1.05-1.813 8.64 8.64 0 0 0 .55-2.087h2.05a11.067 11.067 0 0 1-.762 2.887 9.059 9.059 0 0 1-1.488 2.413Zm.2-7.3a8.653 8.653 0 0 0-.55-2.113 6.957 6.957 0 0 0-1.05-1.787l1.4-1.4a9.572 9.572 0 0 1 1.538 2.45c.391.9.629 1.85.712 2.85h-2.05Zm-8.95 10.95c-2.55-.3-4.679-1.396-6.387-3.287C2.879 16.771 2.025 14.55 2.025 12c0-2.583.854-4.817 2.563-6.7 1.708-1.883 3.837-2.967 6.387-3.25v2c-2 .283-3.658 1.175-4.975 2.675C4.683 8.225 4.025 9.983 4.025 12c0 2 .658 3.75 1.975 5.25 1.317 1.5 2.975 2.4 4.975 2.7v2Zm5.95-16.25a9.076 9.076 0 0 0-1.9-1.1 7.478 7.478 0 0 0-2.05-.55v-2a9.362 9.362 0 0 1 2.825.687c.9.375 1.742.88 2.525 1.513l-1.4 1.45ZM12 17c-1.35-1.15-2.354-2.213-3.012-3.188C8.329 12.837 8 11.933 8 11.1c0-1.25.404-2.246 1.213-2.987C10.021 7.371 10.95 7 12 7c1.05 0 1.98.371 2.788 1.113C15.596 8.854 16 9.85 16 11.1c0 .833-.33 1.737-.988 2.712C14.354 14.787 13.35 15.85 12 17Zm0-5c.3 0 .554-.104.763-.312a1.04 1.04 0 0 0 .312-.763c0-.283-.104-.533-.312-.75A1.02 1.02 0 0 0 12 9.85c-.3 0-.554.108-.762.325a1.05 1.05 0 0 0-.313.75c0 .3.104.554.313.763.208.208.462.312.762.312Z"
  })));
};

const icons12 = {
  '12-airplane': SvgAirplane$2,
  '12-repeat-event': SvgRepeatEvent
};
const icons16 = {
  '16-arrow-down': SvgArrowDown,
  '16-calendar': SvgCalendar$1,
  '16-checkbox-selected': SvgCheckboxSelected$1,
  '16-checkbox-unselected': SvgCheckboxUnselected$1,
  '16-checkbox-rounded-selected': SvgCheckboxRoundedSelected,
  '16-checkbox-rounded-unselected': SvgCheckboxRoundedUnselected,
  '16-checkmark': SvgCheckmark$1,
  '16-end-location': SvgEndLocation$1,
  '16-info': SvgInfo$1,
  '16-minus': SvgMinus,
  '16-pencil': SvgPencil,
  '16-pin': SvgPin$1,
  '16-plus': SvgPlus,
  '16-search': SvgSearch$1,
  '16-airplane': SvgAirplane$1
};
const icons24 = {
  '24-ac': SvgAc,
  '24-add-additional-driver': SvgAddAdditionalDriver,
  '24-additional-driver': SvgAdditionalDriver,
  '24-guarantee': SvgGuarantee,
  '24-airplane': SvgAirplane,
  '24-amex': SvgAmex,
  '24-android-auto': SvgAndroidAuto,
  '24-apple-pay': SvgApplePay,
  '24-apple': SvgApple,
  '24-arrow-down-small': SvgArrowDownSmall,
  '24-arrow-left': SvgArrowLeft,
  '24-arrow-right-rounded': SvgArrowRightRounded,
  '24-arrow-right-small': SvgArrowRightSmall,
  '24-arrow-right': SvgArrowRight,
  '24-arrow-up-small': SvgArrowUpSmall,
  '24-back-arrow': SvgBackArrow,
  '24-blind-spot-warning': SvgBlindSpotWarning,
  '24-bluetooth': SvgBluetooth,
  '24-breadcrumb-separator': SvgBreadcrumbSeparator,
  '24-calendar': SvgCalendar,
  '24-car-play': SvgCarPlay,
  '24-car-with-key': SvgCarWithKey,
  '24-charger': SvgCharger,
  '24-chat': SvgChat,
  '24-checkbox-selected': SvgCheckboxSelected,
  '24-checkbox-unselected': SvgCheckboxUnselected,
  '24-checkmark-rounded': SvgCheckmarkRounded,
  '24-checkmark': SvgCheckmark,
  '24-close-big': SvgCloseBig,
  '24-close-rounded': SvgCloseRounded,
  '24-close-small': SvgCloseSmall,
  '24-close': SvgClose,
  '24-hurry': SvgHurry,
  '24-high-demand': SvgHighDemand,
  '24-copy': SvgCopy,
  '24-credit-card': SvgCreditCard,
  '24-diners': SvgDiners,
  '24-discover': SvgDiscover,
  '24-docs': SvgDocs,
  '24-end-location': SvgEndLocation,
  '24-envelope': SvgEnvelope,
  '24-eye-crossed': SvgEyeCrossed,
  '24-terminal': SvgTerminal,
  '24-eye': SvgEye,
  '24-facebook': SvgFacebook,
  '24-fuel': SvgFuel,
  '24-gearbox': SvgGearbox,
  '24-generic-address': SvgGenericAddress,
  '24-google': SvgGoogle,
  '24-handshake': SvgHandshake,
  '24-heated-seats': SvgHeatedSeats,
  '24-info-big': SvgInfoBig,
  '24-info-small': SvgInfoSmall,
  '24-info': SvgInfo,
  '24-instagram': SvgInstagram,
  '24-invite': SvgInvite,
  '24-lock': SvgLock,
  '24-lock-and-shield': SvgLockAndShield,
  '24-mastercard': SvgMastercard,
  '24-minus-rounded': SvgMinusRounded,
  '24-notifications': SvgNotifications,
  '24-paper-plane': SvgPaperPlane,
  '24-people': SvgPeople,
  '24-phone-mount': SvgPhoneMount,
  '24-photo': SvgPhoto,
  '24-pin': SvgPin,
  '24-plus-rounded': SvgPlusRounded,
  '24-presentation': SvgPresentation,
  '24-question': SvgQuestion,
  '24-radio-button-selected': SvgRadioButtonSelected,
  '24-radio-button-unselected': SvgRadioButtonUnselected,
  '24-road': SvgRoad,
  '24-search': SvgSearch,
  '24-settings': SvgSettings,
  '24-shared-trip': SvgSharedTrip,
  '24-star': SvgStar,
  '24-suitcase': SvgSuitcase,
  '24-surfer': SvgSurfer,
  '24-trash': SvgTrash,
  '24-twitter': SvgTwitter,
  '24-unlock': SvgUnlock,
  '24-user': SvgUser,
  '24-visa': SvgVisa,
  '24-verified': SvgVerified,
  '24-wallet': SvgWallet,
  '24-warning': SvgWarning,
  '24-yelp': SvgYelp,
  '24-share-location': SvgShareLocation
};
var icons = Object.assign(Object.assign(Object.assign({}, icons12), icons16), icons24);

const Icon = /*#__PURE__*/forwardRef(({
  name,
  color = 'primary',
  onPress,
  testID,
  id,
  width,
  height,
  fill = true,
  altText
}, ref) => {
  const [theme] = useTheme();
  const nameArr = name.split('-');
  const iconType = nameArr.shift();
  const filename = nameArr.join('-');
  const iconPath = `${BASE_CONSUMER_ASSETS_URL}/icons/${iconType}/${filename}.svg`;
  const customSize = !!height && !!width ? {
    width,
    height
  } : undefined;
  const customFill = fill ? theme.shapeFills[color] : 'rgba(0, 0, 0, 0)';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const SVGIcon = icons[name];
  return /*#__PURE__*/React__default.createElement(Box, {
    id: id,
    ref: ref,
    display: "flex",
    onPress: onPress,
    cursor: onPress ? 'pointer' : undefined
  }, iconType === 'flag' ? /*#__PURE__*/React__default.createElement("img", {
    src: iconPath,
    alt: altText || `${filename} flag`,
    width: width || undefined,
    height: height || undefined,
    "data-testid": testID
  }) : /*#__PURE__*/React__default.createElement(SVGIcon, {
    "data-testid": testID,
    size: customSize,
    fill: customFill,
    viewBox: customSize ? '0 0 30 30' : undefined,
    title: altText || `${filename} icon`
  }));
});

export { Icon as default };
//# sourceMappingURL=Icon.js.map
